import { render, staticRenderFns } from "./showInActiveDoctor.vue?vue&type=template&id=5aa6fc2d"
import script from "./showInActiveDoctor.vue?vue&type=script&lang=js"
export * from "./showInActiveDoctor.vue?vue&type=script&lang=js"
import style0 from "./showInActiveDoctor.vue?vue&type=style&index=0&id=5aa6fc2d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports